import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { trigger } from "../modules/Events";

function Home() {
  const { id } = useParams();

  useEffect(() => {
    trigger("TitleChange", `Home Page`);
  }, []);

  return <div>This is the home Page. {id}</div>;
}

export default Home;
